import react from "react";
import styles from "./styles.module.css";
import { Tag } from "antd";
import moment from "moment";
import { useSelector } from "react-redux";import { isHC } from "../../../shared/helpers";

const SkillListing = ({ data, isInvited }) => {
  let formatting_options = {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2
  };

  //********** convert encrypted html code to HTML tags **********
  var cache = {},
    character,
    e = document.createElement("div");
  const msgtxt = (html) => {
    return html?.replace(/([&][^&; ]+[;])/g, function (entity) {
      character = cache[entity];
      if (!character) {
        e.innerHTML = entity;
        if (e.childNodes[0])
        character = cache[entity] = e.childNodes[0].nodeValue;else
        character = "";
      }
      return character;
    });
  };
  const Pdetails = useSelector(
  (state) => state.getProfileDetailsReducer.details);


  //*********************************************//
  return (
    <>
      <div>
        <div className={styles["history-main"]}>
          {data?.length > 0 &&
          <>
              {Pdetails?.user_Schema?.Profiles?.Objective ||
            Pdetails?.user_Schema?.Profiles?.Description ||
            data[0].Description ?
            <div className={styles["Career-summary"]} style={{ padding: window.innerWidth < 786 &&
              '3% 3% 1% 3%'
            }}>
                  <div
              style={{
                fontSize: "16px",
                lineHeight: "19.09px",
                marginBottom: "6px",
                fontWeight: "500"
              }}>
                
                    {window.innerWidth <= 786 && Pdetails?.skill_listings?.length > 0 ?
                Pdetails?.skill_listings[0].Title : null}
                  </div>

                  {/* <div className={styles["career-summary-title"]}>
                Career Summary
                </div>
                <div
                dangerouslySetInnerHTML={{
                __html: msgtxt(
                  Pdetails?.user_Schema?.Profiles?.Objective
                    ? Pdetails?.user_Schema?.Profiles?.Objective
                    : Pdetails?.user_Schema?.Profiles?.Description
                    ? Pdetails?.user_Schema?.Profiles?.Description
                    : data[0].Description
                    ? data[0].Description
                    : null
                ),
                }}
                ></div> */}
              
                </div> :
            null}
              <div className={styles["job-type"]}>
                <div className={styles["career-summary-title"]}>Job type</div>
                <span>{data[0]?.JobOrderTypes?.JobOrderTypeName}</span>
              </div>

              <div className={styles['job-type']}>
                <div className={styles['career-summary-title']}>Skills</div>
                {
              data[0]?.SkillListings_Skills?.map((res, index) => {
                return <div className={styles['skill-taged']} key={index}>{res?.SkillName}</div>;
              })}
              
              </div>   
            <div className={styles['job-type']}>
  <div className={styles['career-summary-title']}>
    {isInvited ? "Willing to relocate" : "Desired Locations"}
  </div>
  {data?.[0]?.SkillListings_Cities?.length > 0 ?
              isInvited ?
              data[0].SkillListings_Cities.map((res, index) =>
              <Tag key={index} className={styles['skill-tags']}>
        {res?.Location || "N/A"}
      </Tag>) :


              data[0].SkillListings_Cities.map((res, index) =>
              <Tag key={index} className={styles['skill-tags']}>
        {
                res?.Cities?.LocationWithCountry ?
                res.Cities.LocationWithCountry :
                res?.Cities?.CityName ?
                res.Cities.CityName :
                res?.Location ?
                res.Location :
                "N/A"}
                
      </Tag>) :



              "N/A"}
              
            </div>

              <div className={styles["job-type"]}>
                <div className={styles["career-summary-title"]}>
                  {isHC(Pdetails?.user_Schema?.Professions?.ProfessionCode) ?
                "Desired Salary" :
                data[0]?.JobOrderTypes?.JobOrderTypeName == "Contract" ?
                "Estimated Bill Rate" :
                "Estimated Annual Salary"}
                </div>
                {
              isHC(Pdetails?.user_Schema?.Professions?.ProfessionCode) ?
              data[0]?.MinimumBid?.$numberDecimal ||
              data[0]?.MinimumBid ?
              <span>
                        {`$ ${
                data[0]?.MinimumBid?.$numberDecimal ?
                Math.floor(
                data[0]?.MinimumBid?.$numberDecimal.toLocaleString(
                "en-US")) :


                data[0]?.MinimumBid.toLocaleString("en-US")
                }
                  /${
                data[0]?.BudgetTypes ?
                data[0]?.BudgetTypes?.BudgetTypeName === "Hour" ||
                data[0]?.BudgetTypes?.BudgetTypeName === "Hourly" ?
                "HR" :
                data[0]?.BudgetTypes?.BudgetTypeName === "Yearly" ||
                data[0]?.BudgetTypes?.BudgetTypeName === "Year" ?
                "YR" :
                data[0]?.BudgetTypes?.BudgetTypeName === "Week" ||
                data[0]?.BudgetTypes?.BudgetTypeName === "Weekly" ?
                "WK" :
                data[0]?.JobOrderTypes?.JobOrderTypeName ===
                "Permanent" ?
                "YR" :
                "HR" :
                "YR" //data[0]?.BudgetTypes?.BudgetTypeName   if there is nothing, use hard coded budget type
                }`}
                      </span> :

              "$Negotiable" :

              data[0]?.ClientRate !== null ?
              <span>
                      {`${
                data[0]?.ClientRate?.$numberDecimal ?
                data[0]?.ClientRate?.$numberDecimal.toLocaleString(
                "en-US",
                formatting_options) :

                data[0]?.ClientRate?.toLocaleString(
                "en-US",
                formatting_options)

                }  
                    /${
                data[0]?.BudgetTypes ?
                data[0]?.BudgetTypes?.BudgetTypeName === "Hour" ||
                data[0]?.BudgetTypes?.BudgetTypeName === "Hourly" ?
                "HR" :
                data[0]?.BudgetTypes?.BudgetTypeName === "Yearly" ||
                data[0]?.BudgetTypes?.BudgetTypeName === "Year" ?
                "YR" :
                data[0]?.BudgetTypes?.BudgetTypeName === "Week" ||
                data[0]?.BudgetTypes?.BudgetTypeName === "Weekly" ?
                "WK" :
                data[0]?.JobOrderTypes?.JobOrderTypeName ===
                "Permanent" ?
                "YR" :
                "HR" :
                "YR" //data[0]?.BudgetTypes?.BudgetTypeName   if there is nothing, use hard coded budget type
                }`}
                    </span> :

              "$Negotiable"

              // data[0]?.MinimumBid?.$numberDecimal || data[0]?.MinimumBid ?
              //   <span>
              //     {`$
              //   ${isHC(Pdetails?.user_Schema?.Professions?.ProfessionCode) ?
              //   Math.floor(data[0]?.MinimumBid?.$numberDecimal ? data[0]?.MinimumBid?.$numberDecimal : data[0]?.MinimumBid) :
              //   data[0]?.ClientRate.toFixed(2)}

              //   /${data[0]?.BudgetTypes ? data[0]?.BudgetTypes?.BudgetTypeName === "Hour" ? "hr" : data[0]?.BudgetTypes?.BudgetTypeName === "Yearly" || data[0]?.BudgetTypes?.BudgetTypeName === "Year" ? "yr" : data[0]?.BudgetTypes?.BudgetTypeName === "Week" || data[0]?.BudgetTypes?.BudgetTypeName === "Weekly" ? "wk" : "yr" : data[0]?.BudgetTypes?.BudgetTypeName}`}</span>
              //   :
              //   <div>
              //     {
              //       `$${data[0]?.MinimumBid?.$numberDecimal?data[0]?.MinimumBid?.$numberDecimal:data[0]?.MinimumBid}/${data[0]?.BudgetTypes ? data[0]?.BudgetTypes?.BudgetTypeName === "Hour" ? "hr" : data[0]?.BudgetTypes?.BudgetTypeName === "Yearly" || data[0]?.BudgetTypes?.BudgetTypeName === "Year" ? "yr" : data[0]?.BudgetTypes?.BudgetTypeName === "Week" || data[0]?.BudgetTypes?.BudgetTypeName === "Weekly" ? "wk" : "yr" : data[0]?.BudgetTypes?.BudgetTypeName}`
              //     }
              //   </div>
              }
              </div>

              {/* {data[0]?.IdealStartDate === "Invalid date" || data[0]?.IdealStartDate === null &&
              <div className={styles['job-type']}>
              <div className={styles['career-summary-title']}>Availability</div>
              <span>{data[0]?.IdealStartDate ?
                moment(data[0]?.IdealStartDate).format('MMMM DD, YYYY') :
                moment(data[0]?.StartDate).format('MMMM DD, YYYY')
              }</span>
              </div>} */}

              {data[0]?.StartDate &&
            data[0]?.StartDate != null &&
            data[0]?.StartDate != undefined &&
            data[0]?.StartDate != "" ?
            <div className={styles["job-type"]}>
                  <div className={styles["career-summary-title"]}>
                    {isInvited ? "Availability" : "Available to start"}
                  </div>
                  {moment(data[0]?.StartDate).format("MMMM DD, YYYY")}
                </div> :
            null}
            </>}
          
        </div>
      </div>
    </>);

};

export default SkillListing;